import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import '@/shared/tokens/base.css';
import '@/shared/i18n/i18n';

import { DemoGate } from '@/features/demo';

import { Providers } from './app/Providers';
import { SuspendedGate } from './app/SuspendedGate';
import { router } from './app/routes';

const container = document.getElementById('root');
if (!container) throw new Error('Brak elementu #root — sprawdź index.html.');

createRoot(container).render(
  <StrictMode>
    <Providers>
      {/* ⭐ Bramka wstrzymania obejmuje WSZYSTKO — także pasek demo i ekran logowania.
          Wstrzymanie dotyczy całej firmy, więc nie ma pod nim ekranu, który dalej działa. */}
      <SuspendedGate>
        {/* Pasek demo stoi NAD routerem, bo ma żyć także na /login (spec paska:
            wejście = 1 klik z ekranu logowania). U zwykłych tenantów DemoGate
            renderuje null i nie pobiera nawet swojego chunka. */}
        <DemoGate />
        <RouterProvider router={router} />
      </SuspendedGate>
    </Providers>
  </StrictMode>,
);
